export default "__VITE_ASSET__e244db9c__"